import React, { useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import SettingsIcon from "@mui/icons-material/Settings";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Link from "@mui/material/Link";
import TokenService from "../utility";
import { loadSettings } from "../redux/actions/settings.actions";
import { useDispatch, useSelector } from "react-redux";
import MenuBar from "./menubar";
import { pages, settings } from "./menus";

import { storeStateType } from "../redux/store";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { SET_THEME_MODE } from "../redux/types/ui.types";

import { Helmet } from "react-helmet";

type siteSettingsType = {
  site_title?: string;
  site_logo?: string;
  site_contact_email?: string;
  site_contact_number?: string;
  site_contact_address?: string;
  site_website?: string;
  terms_cond?: string;
};

const Header: React.FunctionComponent = () => {
  let navigate = useNavigate();
  let role = TokenService.getTokenUserRole();
  let user = TokenService.getTokenUser();
  const dispatch = useDispatch();
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );
  const [siteSttings, setSiteSettings] = React.useState<siteSettingsType>();
  const globalSettings = useSelector(
    (state: storeStateType) => state.sitesetting.settings
  );

  const { themeMode } = useSelector((state: storeStateType) => state.UI);

  //for theme
  useEffect(() => {
    if (localStorage.getItem("themeMode") === "dark") {
      dispatch<any>({ type: SET_THEME_MODE, payload: "dark" });
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch<any>(loadSettings());
  }, [dispatch]);

  useEffect(() => {
    if (globalSettings) {
      globalSettings.forEach((item: any) => {
        if (item["config_name"] === "site") {
          setSiteSettings(JSON.parse(item["config_value"]));
        }
        if (item["config_name"] === "employee") {
          //window.localStorage.setItem('employeeSettings', item['config_value'])
          TokenService.saveEmloyeeSettings(item["config_value"]);
        }
      });
    }
  }, [globalSettings]);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogOut = () => {
    //localStorage.clear();
    TokenService.clear();
    window.location.href = "/";
  };

  const handleThemeChange = () => {
    if (themeMode === "light") {
      dispatch({ type: SET_THEME_MODE, payload: "dark" });
      localStorage.setItem("themeMode", "dark");
    } else {
      dispatch({ type: SET_THEME_MODE, payload: "light" });
      localStorage.setItem("themeMode", "light");
    }
  };

  return (
    <AppBar position="absolute" sx={{ backgroundColor: "background.paper" }}>
      <Helmet>
        <title>GNA</title>
      </Helmet>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {siteSttings?.site_logo && (
            <Box
              component="img"
              sx={{
                display: { xs: "none", md: "flex", height: "40px" },
                mr: 1,
              }}
              src={siteSttings?.site_logo}
            />
          )}
          {siteSttings && (
            <Typography
              variant="h6"
              noWrap
              component={RouterLink}
              to="/"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 500,
                textDecoration: "none",
              }}
            >
              {siteSttings.site_title}
            </Typography>
          )}
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page, index) =>
                page.role.includes(role) ? (
                  <MenuItem
                    key={page.title + index}
                    onClick={handleCloseNavMenu}
                  >
                    <Typography textAlign="center">
                      <Link
                        component={RouterLink}
                        underline="none"
                        variant="overline"
                        to={page.route}
                      >
                        {page.title}
                      </Link>
                    </Typography>
                  </MenuItem>
                ) : (
                  <div key={index}></div>
                )
              )}
            </Menu>
          </Box>
          {siteSttings?.site_logo && (
            <Box
              component="img"
              sx={{
                display: { xs: "flex", md: "none", height: "40px" },
                mr: 1,
              }}
              src={siteSttings?.site_logo}
            />
          )}
          <Typography
            variant="h6"
            noWrap
            component={RouterLink}
            to="/"
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 500,
              textDecoration: "none",
            }}
          >
            {siteSttings?.site_title}
          </Typography>

          <MenuBar />

          <Box sx={{ flexGrow: 0 }}>
            <IconButton onClick={handleThemeChange}>
              {themeMode === "light" ? <DarkModeIcon /> : <LightModeIcon />}
            </IconButton>

            <IconButton
              size="large"
              aria-label="setting"
              onClick={() => {
                navigate("/config");
              }}
            >
              <SettingsIcon />
            </IconButton>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt={user.fullname} src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem
                  key={setting.title}
                  onClick={() => {
                    setAnchorElUser(null);
                    navigate(setting.route);
                  }}
                >
                  <Typography textAlign="center">{setting.title}</Typography>
                </MenuItem>
              ))}
              <MenuItem key="logout_page" onClick={handleLogOut}>
                <Typography textAlign="center">Logout</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
